var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginRedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ED4731"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0909 14C20.5864 14 17.7273 16.8591 17.7273 20.3636C17.7273 22.5545 18.8455 24.5 20.54 25.6482C17.2973 27.0391 15 30.2573 15 34H16.8182C16.8182 29.9727 20.0636 26.7273 24.0909 26.7273C28.1182 26.7273 31.3636 29.9727 31.3636 34H33.1818C33.1818 30.2573 30.8845 27.04 27.6418 25.6473C28.5067 25.0634 29.2153 24.2765 29.7056 23.3554C30.196 22.4343 30.4531 21.4071 30.4545 20.3636C30.4545 16.8591 27.5955 14 24.0909 14ZM24.0909 15.8182C26.6118 15.8182 28.6364 17.8427 28.6364 20.3636C28.6364 22.8845 26.6118 24.9091 24.0909 24.9091C21.57 24.9091 19.5455 22.8845 19.5455 20.3636C19.5455 17.8427 21.57 15.8182 24.0909 15.8182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRedIcon);
export default __webpack_public_path__ + "static/media/login-red-icon.7bdc34b4d754710cdfb0bb25307860ef.svg";
export { ForwardRef as ReactComponent };